import React from "react";
import styled from "styled-components";
import {Link} from "gatsby";

import Colors from "../../constants/colors";
import Breakpoints from "../../constants/breakpoints";
import Breadcrumbs from "./breadcrumbs";
import icon_close_normal from "../../images/icons/icon-close.svg";
import icon_close_hover from "../../images/icons/icon-close-hover.svg";
import icon_caret_left_normal from "../../images/icons/icon-caret_left.svg";
import icon_caret_left_hover from "../../images/icons/icon-caret_left-hover.svg";

const TopBar = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 64px;
  padding-right: 16px;
  position: fixed;
  z-index: 100;
  background-color: ${Colors.Background.main_nav};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition-property: all;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
`;


const BreadcrumbsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 90rem;
`

const ExitButton = styled(Link)`
  width: 44px;
  height: 44px;
  background-image: url(${icon_close_normal});
  background-position: 50% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  position: relative;

  &:hover {
    background-image: url(${icon_close_hover});
  }

  @media only screen and (max-width: ${Breakpoints.Width.tablet_small}) {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    background-image: url(${icon_caret_left_normal});

    &:hover {
      background-image: url(${icon_caret_left_hover});
    }
  }
`;

const ProjectHeader = props => {
  return (
    <TopBar>
      <BreadcrumbsContainer>
        <Breadcrumbs currentProject={props.projectTitle} />
        <ExitButton to="/#portfolio"/>
      </BreadcrumbsContainer>
    </TopBar>
  );
};


export default ProjectHeader;